/**
 * @Author: v_jppjpeng
 * @Date: 2023-04-03 17:03:21
 * @Explain: 链接 - 格式化
 */

import { createSearchParams } from 'umi';

/**
 *  序列化
 *  对象： { foo: 'bar', qux: 'qoo'} => foo=bar&qux=qoo
 *  数组：([["foo", "1"], ["bar", "2"]] => foo=1&bar=2
 */
export const onSerialize = (obj: Record<any, any> | any[]) =>
  createSearchParams(obj).toString();

/**
 * @module getUrlParams
 * @description 获取url中的参数，可以
 * @param {String} url 一个url地址，可以不传，默认会取window.location.href
 * @returns {*} 返回一个对象
 */
export const getUrlParams = (url?: string) => {
  const _url = url || window.location.href;
  const _urlParams = _url.match(/([?&])(.+?=[^&]+)/gim);
  return _urlParams
    ? _urlParams.reduce((a: any, b: any) => {
        const value = b.slice(1).split('=');
        a[value[0]] = value[1];
        return a;
      }, {})
    : {};
};
